const convertMapToArray = (input_map) => {
  console.log("inside convertMapToArray");
  const tempArray = [];
  for (const [key, value] of Object.entries(input_map)) {
    tempArray.push({
      key: Math.random() * Math.random() * Math.random() * Math.random(),
      fieldapiname: key,
      labelname : key.includes('land') ? 'Land' : (key.includes('build') || key.includes('house')) ? 'Build' : key.includes('property') ? 'Property' : key.includes('totallots') ? 'Count' :  ( key == 'totalvalue'  || key == 'size' || key == 'valuation' ) ? "Total" : "" ,
      value: value ? value : 0,
    });
  }
  return tempArray;
};

export default convertMapToArray;
